import { render, staticRenderFns } from "./my-upload3.vue?vue&type=template&id=460845a8&scoped=true"
import script from "./my-upload3.vue?vue&type=script&lang=js"
export * from "./my-upload3.vue?vue&type=script&lang=js"
import style0 from "./my-upload3.vue?vue&type=style&index=0&id=460845a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460845a8",
  null
  
)

export default component.exports